/**
 * @generated SignedSource<<c896c1d59e79b1780c54964112436e24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type detailsPageGeneralAssetQuery$variables = {
  generalAssetId: string;
};
export type detailsPageGeneralAssetQueryVariables = detailsPageGeneralAssetQuery$variables;
export type detailsPageGeneralAssetQuery$data = {
  readonly generalAsset: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"GeneralTab_generalAsset" | "LocationTab_asset">;
  } | null;
};
export type detailsPageGeneralAssetQueryResponse = detailsPageGeneralAssetQuery$data;
export type detailsPageGeneralAssetQuery = {
  variables: detailsPageGeneralAssetQueryVariables;
  response: detailsPageGeneralAssetQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "generalAssetId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "generalAssetId",
    "variableName": "generalAssetId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "detailsPageGeneralAssetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GeneralAsset",
        "kind": "LinkedField",
        "name": "generalAsset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GeneralTab_generalAsset"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LocationTab_asset"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "detailsPageGeneralAssetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GeneralAsset",
        "kind": "LinkedField",
        "name": "generalAsset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generalAssetName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeasurementConnection",
            "kind": "LinkedField",
            "name": "currentMeasurements",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeasurementEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Measurement",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeasurementTemplate",
                        "kind": "LinkedField",
                        "name": "template",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serial",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "installedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "warrantyExpiresAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastServicedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "model",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "family",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "manufacturer",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "coordinates",
                "storageKey": null
              }
            ],
            "type": "Asset",
            "abstractKey": "__isAsset"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3eb906a1277069ae0c723eaaa6bfbe6d",
    "id": null,
    "metadata": {},
    "name": "detailsPageGeneralAssetQuery",
    "operationKind": "query",
    "text": "query detailsPageGeneralAssetQuery(\n  $generalAssetId: ID!\n) {\n  generalAsset(generalAssetId: $generalAssetId) {\n    id\n    ...GeneralTab_generalAsset\n    ...LocationTab_asset\n  }\n}\n\nfragment DetailsSection_generalAsset on GeneralAsset {\n  id\n  status\n  generalAssetName\n}\n\nfragment GeneralTab_generalAsset on GeneralAsset {\n  id\n  ...IdentificationSection_asset\n  ...HistorySection_asset\n  ...ManufacturingSection_asset\n  ...DetailsSection_generalAsset\n  currentMeasurements {\n    ...MeasurementsSection_currentMeasurements\n  }\n}\n\nfragment HistorySection_asset on Asset {\n  __isAsset: __typename\n  id\n  installedAt\n  warrantyExpiresAt\n  lastServicedAt\n}\n\nfragment IdentificationSection_asset on Asset {\n  __isAsset: __typename\n  id\n  serial\n  externalId\n}\n\nfragment LocationTab_asset on Asset {\n  __isAsset: __typename\n  id\n  coordinates\n}\n\nfragment ManufacturingSection_asset on Asset {\n  __isAsset: __typename\n  id\n  model {\n    __typename\n    id\n    name\n  }\n  family {\n    __typename\n    id\n    name\n  }\n  manufacturer {\n    __typename\n    id\n    name\n  }\n}\n\nfragment MeasurementsSection_currentMeasurements on MeasurementConnection {\n  edges {\n    node {\n      id\n      value\n      createdAt\n      template {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef488bf2d8435d3e1b458e9f72ea2488";

export default node;
